import React, { type ReactNode } from 'react';
import type { Config } from 'src/config';
import type { Client } from 'src/getGraphqlClient';

import type { ClientContext } from '../../types';

import AppConfigContext from './AppConfigContext';

export type AppConfig = ClientContext & Config & Client;
interface AppConfigProviderProps {
  value: AppConfig;
  children: ReactNode;
}

const AppConfigProvider = ({ value, children }: AppConfigProviderProps) => (
  <AppConfigContext.Provider value={value}>
    {children}
  </AppConfigContext.Provider>
);

export default AppConfigProvider;
